import type { StorageBlobHttpHeaders } from '../../../../types/azureStorage';
import { Button } from '../../../../components/ui/button';
import { Input } from '../../../../components/ui/input';
import { PropertiesConflictNotice } from './PropertiesConflictNotice';

const EDITABLE: Array<[keyof StorageBlobHttpHeaders, string]> = [
  ['contentType', 'Content type'], ['contentLanguage', 'Content language'],
  ['contentEncoding', 'Content encoding'], ['contentDisposition', 'Content disposition'],
  ['cacheControl', 'Cache control'],
];

export function PropertiesHeadersForm(props: {
  value: StorageBlobHttpHeaders;
  onChange: (value: StorageBlobHttpHeaders) => void;
  onSave: () => void;
  disabled?: boolean;
  disabledReason?: string;
  saveDisabled?: boolean;
  message?: string;
  /** F20: `reloading` turns the notice's Reload off while a reload runs (every editor is locked meanwhile). */
  conflict?: { message: string; onReload: () => void; reloading?: boolean };
}) {
  return (
    <section className="space-y-2" data-testid="storage-properties-headers-section">
      <h3 className="text-sm font-medium">HTTP headers</h3>
      {EDITABLE.map(([key, label]) => (
        <label key={key} className="grid grid-cols-[7rem_minmax(0,1fr)] items-center gap-2 text-xs">
          <span className="text-muted-foreground">{label}</span>
          <Input spellCheck={false} autoComplete="off" value={props.value[key] ?? ''} disabled={props.disabled} title={props.disabledReason} onChange={(event) => props.onChange({ ...props.value, [key]: event.target.value || undefined })} />
        </label>
      ))}
      {props.value.contentMD5 && <p className="text-xs text-muted-foreground">Content MD5 (read-only): {props.value.contentMD5}</p>}
      {props.conflict && <PropertiesConflictNotice message={props.conflict.message} onReload={props.conflict.onReload} reloading={props.conflict.reloading} testId="storage-properties-headers" />}
      <div className="flex items-center gap-2">
        <Button type="button" size="xs" disabled={props.disabled || props.saveDisabled || !!props.conflict} title={props.disabledReason} onClick={props.onSave} data-testid="storage-properties-headers-save">Save</Button>
        {props.message && <span className="text-xs text-muted-foreground">{props.message}</span>}
      </div>
    </section>
  );
}
